<template>
  <div class="list-item list-none"><slot /></div>
</template>
